import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=4aaa8571&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=4aaa8571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa8571",
  null
  
)

export default component.exports